import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import PageTitle from 'backOfficeComponents/base/pageTitle/pageTitle';
import SectionTitleBar from 'backOfficeComponents/base/sectionTitleBar/sectionTitleBar';
import storeService from 'services/storeService';
import Table from 'components/table/table';
import { tableColumns, initialSorting } from 'services/tableColumns';
import constants from 'services/constants';
import Routing from 'routing';
import PropTypes from 'prop-types';

const BoMyActivity = ({
  setModal
}) => {
  const sessionMyActivity = storeService.session.get.searchResultsMyActivity();
  const { ready } = useTranslation();
  const [data, setData] = React.useState(sessionMyActivity ? sessionMyActivity.data : []);
  const history = useHistory();

  const userName = storeService.session.get.loggedInUser() ? storeService.session.get.loggedInUser() : '';

  const tableParams = {
    request: {
      url: '/userActivity',
      params: {
        userName: userName?.userName,
        eventType: 'myActivity'
      },
      processData: (data) => data.map((row) => ({
        ...row,
        status: row.isFullUndone ? constants.status.cancelled : row.requestStatus
      }))
    }
  };

  useEffect(() => {
    const unListen = history.listen((path) => {
      if (path.pathname.substring(0, Routing.boMyActivity.length) !== Routing.boMyActivity) {
        storeService.session.removeAll.tableFilters();
        storeService.session.removeAll.searchResults();
        unListen();
      }
    });
  }, [history]);

  return (
    <>
      {ready &&
        <>
          <PageTitle
            id="myActivityTitle"
            pageTitleOne="boApp.pageTitles.myActivity.myActivity"
          />
          <div className="pageContent">
            <SectionTitleBar
              icon="bi bi-search"
              id="myActivityTitleBar"
              title="boApp.label.myActivity"
            />
            <Table
              columns={tableColumns.bo.myActivity}
              data={data}
              fetchingDataLabel="label.fetchingMyActivity"
              initialSortBy={initialSorting.bo.myActivity.requestId.accessor}
              initialSortDirection={initialSorting.bo.myActivity.requestDate.direction}
              params={tableParams}
              setData={setData}
              setModal={setModal}
              store={{
                filters: 'MyActivity',
                data: 'MyActivity'
              }}
            />
          </div>
        </>
      }
    </>
  );
};

BoMyActivity.propTypes = {
  setModal: PropTypes.func.isRequired
};

export default BoMyActivity;
